<template>
  <v-dialog ref="dateDialog" v-model="dateModal" persistent width="820px">
    <!--    :return-value.sync="pre_alert.slot"-->
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="pre_alert.slot"
        :label="$t('book_slot')"
        prepend-icon="mdi-calendar"
        readonly
        clearable
        outlined
        dense
        :error-messages="slotErrors"
        v-bind="attrs"
        @click="checkWarehouse"
      />
    </template>
    <div class="bg-off-white rounded-lg poppins">
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-size-h3 text-dark-65 font-weight-bolder">
          {{ $t("select_date_and_time") }}
        </h4>
        <!--begin::Close-->
        <div
          class="btn btn-sm btn-secondary btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="20">mdi-close</v-icon>
          </span>
        </div>
        <!--end::Close-->
      </div>
      <div
        class="bg-off-white modal-body d-flex justify-space-between px-4 py-0 poppins"
      >
        <div class="w-100 my-8 pt-0 px-4">
          <div class="d-flex align-center">
            <v-date-picker
              v-model="pre_alert.expected_arrival_time"
              class="date-slot-picker font-size-lg"
              color="deep-purple accent-2"
              scrollable
              no-title
              :min="today"
              :first-day-of-week="1"
              @click:date="handleDateSelect"
              @update:picker-date="handleDateChange"
              :allowed-dates="isDateAvailable"
            />
            <!--            :events="getDateColor"-->
          </div>
        </div>
        <div class="border"></div>
        <div
          v-if="pre_alert.expected_arrival_time && slotsForSelectedDate.length"
          class="time-slots-container w-100 h-300px scroll-y my-9 px-8 ps-12"
        >
          <button
            v-for="(item, index) in slotsForSelectedDate"
            :key="index"
            :disabled="item.booked"
            style="
              margin: 0 !important;
              width: 150px !important;
              height: 50px !important;
            "
            class="btn font-size-lg py-3 border"
            :class="{
              'date-slot__btn': item.booked === false,
              'btn-secondary': item.booked === true,
              'active date-slot__btn-border btn-light-info text-white':
                selected === index,
            }"
            @click.prevent="() => handleSelect(index)"
          >
            <span v-if="selected === index || item.booked" class="svg-icon">
              <v-icon size="18">{{
                selected === index
                  ? "mdi-check"
                  : item.booked
                  ? "mdi-close"
                  : ""
              }}</v-icon>
            </span>
            {{ item.start + "-" + item.end }}
          </button>
        </div>
        <div v-else class="d-flex align-center justify-center w-100 px-4">
          <h4
            class="mb-0 font-size-h3 text-dark-65 font-weight-bolder text-center"
          >
            {{
              !pre_alert.expected_arrival_time
                ? $t("choose_date")
                : $store.getters.getPageLoading
                ? $t("loading_dots")
                : resolveSlotMessage(errorMessage)
            }}
          </h4>
        </div>
      </div>

      <!-- Continue Button -->
      <div class="modal-footer d-flex justify-end px-14 py-4">
        <button class="btn btn-info px-6 py-3" @click="handleContinue">
          {{ $t("next") }}
        </button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Swal from "sweetalert2";
import ApiService from "@/core/services/api.service";

export default {
  name: "DateSlotPicker",
  props: ["pageLoader", "pre_alert", "slotErrors"],
  data: function () {
    return {
      dateModal: false,
      today: new Date().toISOString().split("T")[0],
      errorMessage: "no_slots_available",
      selected: -1,
      availableDates: [],
      schedule: [],
      slotsForSelectedDate: [],
      // availableDates: [
      //   "2025-07-08",
      //   "2025-07-09",
      //   "2025-07-12",
      //   "2025-07-15",
      //   "2025-07-20",
      // ],
    };
  },
  methods: {
    resolveSlotMessage(msg) {
      if (!msg) {
        return "";
      }
      if (this.$te(msg)) {
        return this.$t(msg);
      }
      return msg;
    },
    async handleDateChange(date) {
      if (date.split("-")[1] && !this.$store.getters.getPageLoading) {
        const lastDashIndex = this.today.lastIndexOf("-");
        const thisMonth = this.today.substring(0, lastDashIndex);

        if (date > thisMonth) {
          await this.getAvailableDates(date + "-01");
        } else if (date === thisMonth) {
          await this.getAvailableDates();
        }
      }
    },
    handleDateSelect(date) {
      if (date) {
        const daySchedule = this.schedule.find((day) => day.date === date);

        this.selected = -1;
        if (daySchedule && !daySchedule.fully_booked) {
          this.slotsForSelectedDate = daySchedule.slots;
        } else {
          this.slotsForSelectedDate = [];
          this.errorMessage = "no_slots_available";
        }
      }
    },
    getDateColor(date) {
      if (date) {
        const daySchedule = this.schedule.find((day) => day.date === date);

        if (daySchedule && daySchedule?.fully_booked) return "red"; // Fully booked

        return false;
      }
    },
    isDateAvailable(date) {
      if (date) {
        return this.availableDates.includes(date);
      }
    },
    getAvailableDatesFromSchedule() {
      this.availableDates = this.schedule.map((day) => day.date);
      // this.availableDates = this.schedule
      //   .filter((day) => !day.fully_booked)
      //   .map((day) => day.date);
    },
    handleContinue() {
      if (this.selected !== -1) {
        const selectedSlot = this.slotsForSelectedDate[this.selected];
        const slotValue = " " + selectedSlot.start + "-" + selectedSlot.end;
        this.pre_alert.slot = this.pre_alert.expected_arrival_time + slotValue;
        this.dateModal = false;
      }
    },
    async getAvailableDates(date = this.today) {
      this.pageLoader(true);
      await ApiService.post(
        "/fulfillment/asn/get_warehouse_weekday_time_slots",
        {
          date,
          warehouse_id: this.pre_alert.warehouse_id,
        }
      )
        .then(({ data }) => {
          this.slotsForSelectedDate = [];
          this.selected = -1;

          if (data.success) {
            this.schedule = data.schedule;
            this.getAvailableDatesFromSchedule();
            this.errorMessage = "no_slots_available";
            this.dateModal = true;
          } else {
            this.errorMessage = data.message;
            this.schedule = [];
            this.availableDates = [];
            this.slotsForSelectedDate = [];
          }
        })
        .finally(() => {
          this.pageLoader(false);
        });
    },
    async checkWarehouse() {
      if (!this.pre_alert.warehouse_id) {
        Swal.fire({
          title: this.$t("warning"),
          text: this.$t("please_select_warehouse"),
          icon: "warning",
          showConfirmButton: false,
        });
        return;
      } else {
        await this.getAvailableDates();
        // this.dateModal = true;
        // this.slotsForSelectedDate = [];
        // this.errorMessage = "No slots available";
        // this.selected = -1;
      }
    },
    toggleModal() {
      this.slotsForSelectedDate = [];
      this.errorMessage = "no_slots_available";
      this.selected = -1;
      this.pre_alert.slot = "";
      this.pre_alert.expected_arrival_time = "";
      this.dateModal = !this.dateModal;
    },
    handleSelect(index) {
      if (this.selected === index) this.selected = -1;
      else this.selected = index;
    },
  },
  // computed: {
  //   slots() {
  //     return [
  //       {
  //         start: "08:00",
  //         end: "08:30",
  //         booked: true,
  //       },
  //       {
  //         start: "08:30",
  //         end: "09:00",
  //         booked: false,
  //       },
  //       {
  //         start: "09:00",
  //         end: "09:30",
  //         booked: false,
  //       },
  //       {
  //         start: "09:30",
  //         end: "10:00",
  //         booked: false,
  //       },
  //       {
  //         start: "10:35",
  //         end: "11:05",
  //         booked: false,
  //       },
  //       {
  //         start: "11:05",
  //         end: "11:35",
  //         booked: false,
  //       },
  //       {
  //         start: "11:35",
  //         end: "12:05",
  //         booked: false,
  //       },
  //       {
  //         start: "08:00",
  //         end: "08:30",
  //         booked: true,
  //       },
  //       {
  //         start: "08:30",
  //         end: "09:00",
  //         booked: false,
  //       },
  //       {
  //         start: "09:00",
  //         end: "09:30",
  //         booked: false,
  //       },
  //       {
  //         start: "09:30",
  //         end: "10:00",
  //         booked: true,
  //       },
  //       {
  //         start: "10:35",
  //         end: "11:05",
  //         booked: false,
  //       },
  //       {
  //         start: "11:05",
  //         end: "11:35",
  //         booked: false,
  //       },
  //       {
  //         start: "11:35",
  //         end: "12:05",
  //         booked: false,
  //       },
  //     ];
  //   },
  // },
};
</script>

<style scoped>
.bg-off-white {
  background-color: #f7f7f9;
}

.time-slots-container {
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 12px !important;
  align-content: flex-start !important;
}

.date-slot__btn {
  border: 1px solid #8043fd !important;
  color: #5e6278 !important;
  font-weight: 600 !important;
}

.date-slot__btn-border {
  border: 1px solid #8043fd !important;
  color: #fff !important;
}
</style>
